import { Footer2018 } from '../footer';
import { use2018Assets } from '../shared';

const SmartCity2018Zh = () => {
  use2018Assets({ lang: 'zh', title: '香港智慧城市峰會暨智慧城市大獎2018' });

  return (
    <>
      <div id="Lightbox">
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>

      <div className="menu_container" id="menu_container">
        <div className="topnav" id="myTopnav">
          <a href="/2018/zh" className="topnav_logo" id="topnav_logo">
            <img src="/2018/images/head_logo_2.png" alt="" />
          </a>
          <div className="tab_container" id="tab_container">
            <a href="/2018/zh" id="tab_home">
              主頁
            </a>
            <a href="/2018/zh/agenda">峰會</a>
            <a href="/2018/zh/awards" className="tab_awards">
              獎項
            </a>
            <a href="/2018/zh/winners" className="tab_winners">
              得獎名單
            </a>
            <a href="/2018/zh/advisory">諮詢委員會</a>
            <div className="dropdown">
              <a href="#" className="dropbtn">
                評審委員會
              </a>
              <div className="dropdown-content">
                <a href="/2018/zh/judges">評審</a>
                <a href="/2018/zh/judges_criteria">評審準則</a>
              </div>
            </div>
            <a href="/2018/zh/sponsors">贊助</a>
            <a href="/2018/zh/highlights">花絮</a>
            <div className="language container" id="language">
              <div className="lang_icon">
                <img src="/2018/images/lang_icon.png" alt="" />
              </div>
              <a
                href="/2018"
                className="language_ch"
                style={{
                  fontFamily: 'Poppins',
                  padding: 0,
                  paddingLeft: 6,
                  textAlign: 'center',
                  color: '#004fad',
                  position: 'absolute',
                  borderBottom: 0,
                  display: 'inline-block',
                }}
              >
                En
              </a>
            </div>
          </div>
          <a
            id="click"
            href="#"
            style={{ fontSize: 15 }}
            className="icon"
            onClick={(e) => {
              e.preventDefault();
              (window as any).myFunction?.();
            }}
          >
            <i className="fa fa-bars" />
          </a>
        </div>
      </div>

      <div id="larger_wrapper">
        <div className="wrapper">
          <div className="head_banner">
            <div className="KV">
              <div id="slideshow">
                <div className="KV_envir a">
                  <img src="/2018/images/SCA_KV_envir_a.jpg" alt="" />
                  <div className="KV_envir b">
                    <img src="/2018/images/SCA_KV_envir_b-min.png" alt="" />
                  </div>
                  <div className="KV_envir c">
                    <img src="/2018/images/SCA_KV_envir_c-min.png" alt="" />
                  </div>
                </div>
                <div className="KV_gov a">
                  <img src="/2018/images/SCA_KV_gov_a.jpg" alt="" />
                  <div className="KV_gov b">
                    <img src="/2018/images/SCA_KV_gov_b-min.png" alt="" />
                  </div>
                  <div className="KV_gov c">
                    <img src="/2018/images/SCA_KV_gov_c-min.png" alt="" />
                  </div>
                </div>
                <div className="KV_liv a">
                  <img src="/2018/images/SCA_KV_liv_a.jpg" alt="" />
                  <div className="KV_liv b">
                    <img src="/2018/images/SCA_KV_liv_b-min.png" alt="" />
                  </div>
                  <div className="KV_liv d">
                    <img src="/2018/images/SCA_KV_liv_d-min.png" alt="" />
                  </div>
                  <div className="KV_liv c">
                    <img src="/2018/images/SCA_KV_liv_c-min.png" alt="" />
                  </div>
                </div>
                <div className="KV_econ a">
                  <img src="/2018/images/SCA_KV_econ_a.jpg" alt="" />
                  <div className="KV_econ b">
                    <img src="/2018/images/SCA_KV_econ_b-min.png" alt="" />
                  </div>
                  <div className="KV_econ c">
                    <img src="/2018/images/SCA_KV_econ_c-min.png" alt="" />
                  </div>
                  <div className="KV_econ d">
                    <img src="/2018/images/SCA_KV_econ_d-min.png" alt="" />
                  </div>
                </div>
                <div className="KV_peo a">
                  <img src="/2018/images/SCA_KV_peo_a.jpg" alt="" />
                  <div className="KV_peo b">
                    <img src="/2018/images/SCA_KV_peo_b-min.png" alt="" />
                  </div>
                  <div className="KV_peo c">
                    <img src="/2018/images/SCA_KV_peo_c-min.png" alt="" />
                  </div>
                  <div className="KV_peo d">
                    <img src="/2018/images/SCA_KV_peo_d-min.png" alt="" />
                  </div>
                </div>
                <div className="KV_mob a">
                  <img src="/2018/images/SCA_KV_mob_a.jpg" alt="" />
                  <div className="KV_mob b">
                    <img src="/2018/images/SCA_KV_mob_b-min.png" alt="" />
                  </div>
                  <div className="KV_mob c">
                    <img src="/2018/images/SCA_KV_mob_c-min.png" alt="" />
                  </div>
                  <div className="KV_mob d">
                    <img src="/2018/images/SCA_KV_mob_d-min.png" alt="" />
                  </div>
                  <div className="KV_mob e">
                    <img src="/2018/images/SCA_KV_mob_e-min.png" alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div id="typing">
              <h3>
                智 慧{' '}
                <span
                  className="txt-rotate"
                  style={{ fontWeight: 600 }}
                  data-period="2000"
                  data-rotate='["環  境", "政  府", "生  活", "經  濟", "市  民", "出  行"]'
                />
                <span className="typed-cursor" style={{ animationIterationCount: 'infinite' }}>
                  |
                </span>
              </h3>
              <h2>
                A single <span>&lt;span&gt;</span> is all you need.
              </h2>
            </div>
          </div>

          <div className="left_head_banner">
            <div className="small_wrapper">
              <a href="/2018/zh" className="head_logo">
                <img src="/2018/images/head_logo.png" alt="" />
              </a>
              <div className="tagline">
                智慧創新
                <br />
                引領更理想
                <br />
                香港
                <div className="scroll_down">
                  更多
                  <div className="scroll_down_arrow">
                    <img src="/2018/images/scroll_down_arrow.png" alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div className="small_wrapper_mobile">
              <div className="head_logo_mobile">
                <img src="/2018/images/head_logo.png" alt="" />
              </div>
              <div className="tagline">
                智慧創新
                <br />
                引領更理想
                <br />
                香港
                <div className="scroll_down">
                  更多
                  <div className="scroll_down_arrow">
                    <img src="/2018/images/scroll_down_arrow.png" alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div className="blue_bg">
              <img src="/2018/images/blue_bg_2.png" alt="" />
            </div>
            <div className="blue_bg_mobile" />
          </div>
        </div>
      </div>

      <div className="wave_bg">
        <img src="/2018/images/wave-top.png" alt="" />
      </div>
      <div className="wave_bg_pattern" />

      <div className="para_introduction">
        <h1>「香港智慧城市峰會暨智慧城市大獎2018」</h1>

        <div className="first_intro">
          <div className="center_introduction">
            <p className="p1">
              智慧城市發展可改善日常生活，令香港成為更宜居的城市。2017年年中發表的《香港智慧城市藍圖顧問研究報告》
              就<b>「智慧出行」、「智慧生活」、「智慧環境」、「智慧市民」、「智慧政府」和「智慧經濟」</b>等6個範疇的發展方案提出短、
              中、長期建議，並指出政府、企業及社區團體需要相互合作，以邁向智慧城市。<br />
              <br />
              香港擁有高人口密度、領先可靠的資訊科技網絡連繫、高外向度、高開放性，以及數一數二的基礎建設。此外，香港的資訊科技水平與世界無縫接軌，
              香港社會對資訊科技的認知度和經驗名列國際前茅，因此，香港在智慧城市的發展上具有明顯的優勢。香港商界和市民須目標一致，
              攜手並肩為香港創造「智慧未來」。
            </p>
          </div>
          <div className="six_cate">
            <div className="animate cate_container" data-animate="bounceIn" data-duration="1.0s" data-delay="0.1s" data-offset="100">
              <img src="/2018/images/smart_mobility_zh.png" alt="" />
              <img src="/2018/images/smart_living_zh.png" alt="" />
              <img src="/2018/images/smart_environment_zh.png" alt="" />
              <img src="/2018/images/smart_people_zh.png" alt="" />
              <img src="/2018/images/smart-government_zh.png" alt="" />
              <img src="/2018/images/smart_economy_zh.png" alt="" />
            </div>
          </div>
        </div>

        <div className="youtubevideowrap">
          <div className="video_container">
            <iframe
              src="https://www.youtube.com/embed/k-kj3cTFGMo?showinfo=0&rel=0"
              frameBorder={0}
              allowFullScreen
            />
          </div>
        </div>

        <div className="aim_bg">
          <div className="aim_event_container">
            <div className="aim_event_wrap">
              <div className="animate aim_text" data-animate="slideInLeft" data-duration="1.0s" data-delay="0.1s" data-offset="100">
                <p style={{ fontSize: 25, fontWeight: 900, margin: 0 }}>「香港智慧城市峰會暨智慧城市大獎2018」</p>
                旨在嘉許、推動和支持通過提升效率、增加業務和提高生活質素，從而可能革新日常生活的創新解決方案或策略;
                獎項同時希望促進未來城市的發展，讓生活質素、創新能力、競爭力，以致管理效率實現升級。
              </div>

              <div className="event_details animate" data-animate="slideInRight" data-duration="1.0s" data-delay="0.1s" data-offset="100">
                <div className="title">
                  <div className="title_text gradient">活動詳情</div>
                </div>
                <div className="details_left">
                  <div className="date">日期:</div>
                  <div className="eleven">
                    <img src="/2018/images/11_zh.png" alt="" />
                  </div>
                </div>
                <div className="details_right">
                  <div className="date venue">地點:</div>
                  <div className="hkcec">香港會議展覽中心</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer2018 lang="zh" />
    </>
  );
};

export default SmartCity2018Zh;

